export default "__VITE_ASSET__C$cde3x1__"